import { SportOfferDataStore } from '@store/modules/data/sportOffer';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    ComputedRef,
} from '@vue/composition-api';

import { SummaryOddsSelection } from '../types/SummaryOddsSelection';
import { useMEBBOddsRepository } from './useMEBBOddsRepository';
import { getSortedSummaryLegs } from '../helpers';

interface MEBBSummaryOddsSelectionsService {
    summaryOddsSelections: ComputedRef<SummaryOddsSelection[]>;
}

export const useMEBBSummaryOddsSelections = (): MEBBSummaryOddsSelectionsService => {
    const _sportOfferDataStore = useVuexStore<SportOfferDataStore>('data/sportOffer');
    const _eventsMap = _sportOfferDataStore.getter('eventsMap');

    const { repository } = useMEBBOddsRepository();

    const summaryOddsSelections = computed(() => {
        const oddsSelections = Object.entries(repository.value).map(([eventId, { preview: { lastLegTimestamp, summary, unavailableOddsUuids }, ...rest }]) => ({
            event: _eventsMap.value[eventId],
            preview: {
                lastLegTimestamp,
                summary: {
                    ...summary,
                    legs: getSortedSummaryLegs(summary?.legs ?? [], rest.selectedOddUuids),
                },
                unavailableOddsUuids,
            },
            ...rest,
        }));

        const filteredOddsSelections = oddsSelections.filter(({ event, preview }) => Boolean(event && preview.summary?.legs.length)) as SummaryOddsSelection[];

        filteredOddsSelections.sort((oddsSelectionA, oddsSelectionB) => {
            if (oddsSelectionA.preview.lastLegTimestamp < oddsSelectionB.preview.lastLegTimestamp) {
                return 1;
            }

            if (oddsSelectionA.preview.lastLegTimestamp > oddsSelectionB.preview.lastLegTimestamp) {
                return -1;
            }

            return 0;
        });

        return filteredOddsSelections;
    });

    return {
        summaryOddsSelections,
    };
};
